<template>
    <v-main class="primary">
        <transition name="fade" mode="out-in">
            <loader-component v-if="loading"></loader-component>
            <router-view v-else></router-view>
        </transition>
    </v-main>
</template>
<style scoped>
    .fade-enter-active,
    .fade-leave-active {
        transition-duration: 0.3s;
        transition-property: opacity;
        transition-timing-function: ease;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0;
    }
</style>
<script>
    import { mapActions, mapMutations, mapGetters } from 'vuex'
    import LoaderComponent from '../../components/LoaderComponent.vue'

    export default {
        components: {
            LoaderComponent,
        },

        async created() {
            this.ENABLE_LOADER()
            this.$vuetify.theme.themes.light.primary = '#fff4f2'
            this.$vuetify.theme.themes.light.secondary = '#F54127'
            this.$vuetify.theme.themes.light.accent = '#F58634'
            this.$vuetify.theme.themes.light.anchor = '#34A871'
            await this.fetchSedes()
            await this.fetchSubsedes()
            await this.fetchRamasByDependencia(2)
            await this.fetchRegiones()
            await this.fetchPuestosByDependencia(2)
            await this.fetchAreas()
            await this.fetchSubareas()
            await this.fetchTiposRegion()
            await this.fetchEstatusPersonal()
            await this.fetchEstados()
            await this.fetchMunicipios()
            await this.fetchEstadoCivil()
            await this.fetchTipoNacionalidad()
            await this.fetchSexo()
            await this.fetchGrupoSanguineo()

            this.DISABLE_LOADER()
        },

        computed: {
            ...mapGetters({
                loading: 'getLoader',
            }),
        },

        methods: {
            ...mapActions('personal', ['fetchPersonal']),

            ...mapActions('dependencia', ['fetchDependencias']),
            ...mapActions('sede', ['fetchSedes']),
            ...mapActions('subsede', ['fetchSubsedes']),
            ...mapActions('categoria', ['fetchCategorias']),
            ...mapActions('rama', ['fetchRamasByDependencia']),
            ...mapActions('region', ['fetchRegiones']),
            ...mapActions('puesto', ['fetchPuestosByDependencia']),
            ...mapActions('areas', ['fetchAreas']),
            ...mapActions('tipoInstancia', ['fetchTiposInstancia']),
            ...mapActions('tipoRegion', ['fetchTiposRegion']),
            ...mapMutations(['DISABLE_LOADER', 'ENABLE_LOADER']),
            ...mapActions('estado', ['fetchEstados']),
            ...mapActions('municipio', ['fetchMunicipios']),
            ...mapActions('estatusPersonal', ['fetchEstatusPersonal']),
            ...mapActions('subareas', ['fetchSubareas']),
            ...mapActions('estadoCivil', ['fetchEstadoCivil']),
            ...mapActions('tipoNacionalidad', ['fetchTipoNacionalidad']),
            ...mapActions('sexo', ['fetchSexo']),
            ...mapActions('grupoSanguineo', ['fetchGrupoSanguineo']),
        },
    }
</script>
